import { Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSButton from "../../../Components/Button/WSButton";
import { callAPI, clearRequest, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import { Header } from "../../../Components/Header/Header";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";

export const TopBrand: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const id = params?.id;
  const [defaultImg, setDefaultImg] = useState<any | null>(null);

  useEffect(
    () => () => {
      reset();
    },
    []
  );
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getTopBrandById(id: any) {
      try {
        const response: any = await callAPI(`TopBrand`, Method.GET, {}, id);
        console.log("response", response);

        if (response && response?.data) {
          setValue("name", response.data.name);
          setDefaultImg(response.data.imageUrl)

          setDefaultImg(response.data.logoUrl)
          setValue("websiteUrl", response.data.websiteUrl);
          setValue("id", response.data.id);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getTopBrandById(id);
    }
  }, [id, setValue]);

  /**
   * Method for Add/Update the data
   * @param data
   */
  const handleData = async (data: any) => {
    try {
      console.log("Submitted data:", data);
      // Extract image name from the uploaded file.
      let imageName = "";
      // if (data.imageUrl && data.imageUrl[0]) {
      //   const file = data.imageUrl[0]; // Assuming `imageUrl` contains an array of files.
      //   imageName = file.name; // Get the file name from the uploaded image.
      // }
      const formData = new FormData()
      if (selectedFile) {
        formData.append("file", selectedFile!);
      }
      formData.append("name", data.name); // Add title
      formData.append("logoUrl", "asdsa");
      formData.append("websiteUrl", data.websiteUrl);

      // const newRequest = clearRequest(request)
      if (id) {
        formData.append("id", id); // Add display
        const response: any = await callAPI(`TopBrand/${id}`, Method.PUTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response?.success === true) {
            navigate('/brand/list')
          }
        }

      } else {
        const response: any = await callAPI("TopBrand/Create", Method.POSTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response?.success === true) {
            navigate('/brand/list')
          }
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  };
  const handleCancelClick = () => {
    navigate('/brand/list')
  }
  const handleUploadFile = (file: any) => {
    setDefaultImg(null)
    if (file && file.length > 0) {
      setSelectedFile(file[0]);
    }
  }
  const handleRemove = (id: string) => {
    alert(id)
  }
  return (
    <>
      <Header type="simple" isDivider={true} title={`${id ? 'Edit' : 'Add'} Top Brand`} url="/brand/list" id={'topbrandImg'} isBackButton={true} headerSx={{ marginTop: 0 }} />
      <form onSubmit={handleSubmit(handleData)}>
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 3,
          }}
        >
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Name"}
                {...register("name")}
                id="name"
                name="name"
                control={control}
                rules={{ required: true }}
              // labelType="Normal"
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
            <WSTextField
              label={"Logo Url"}
              {...register("logoUrl")}
              id="logoUrl"
              name="logoUrl"
              control={control}
              rules={{ required: true }}
              labelType="Normal"
            />
          </Grid> */}
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Website Url *"}
                {...register("websiteUrl")}
                id="websiteUrl"
                name="websiteUrl"
                control={control}
                rules={{ required: true }}
              //labelType="Normal"
              />
            </Grid>
            <Grid item sm={12} style={{ overflow: 'auto' }}>
              <WSFileUpload
                name="imageUrl"
                label="Image"
                control={control}
                rules={{ required: defaultImg ? false : true }}
                acceptFileTypes=".jpg,.jpeg,.png"
                maxFileSizeMB={2}
                defaultValue={defaultImg}
                id={"imageUrl"}
                image={true}
                onChange={handleUploadFile}
                onRemove={handleRemove}
                align="Start"
                isToolTipImg={false}
                multiple={false}
              />
            </Grid>
            <Grid item xs={12} sm={6} style={{ display: "none" }}>
              <WSHiddenField
                name="id"
                control={control}

              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "3rem",
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <WSButton
                id="submit"
                label={"Save"}
                type="submit"
                size="medium"
              />
              <WSButton
                id="cancel"
                label={"Cancel"}
                type="button"
                onClick={handleCancelClick}
                size="medium"
                className="ws-cancel"
              />
            </Grid>
          </Grid>
        </Grid>
      </form>

    </>);
});
